import * as ReqType from '../types/ServerRequests';
import Axios, { AxiosResponse } from 'axios';
import LoginServices from './LoginServices';

/**
 * Cette classe permet la communication entre le backend et le frontend
 * Elle assure l'envois la reception des données entre le backend et frontend
 * Elle permet la creation, modification, et suppression des adresses postales
 */
export class AdresseService {
    private static instance: AdresseService = new AdresseService();

    public static getInstance(): AdresseService {
        return this.instance;
    }

    /**
     * creation
     * @param {Adresse} newAddr
     * @returns {Promise<Adresse>}
     */
    public createAdresse(newAddr: ReqType.Adresse): Promise<ReqType.Adresse> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.post(
            process.env.REACT_APP_ADRESSE_CREATE_URL!,
            newAddr,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            (response: AxiosResponse<ReqType.Adresse>) => {
                return response.data;
            }
        );
    }

    /**
     * mise à jours
     * @param {Adresse} newAddr
     * @param {Adresse} oldAddr
     * @returns {Promise<Adresse>}
     */
    public updateAdresse(newAddr: ReqType.Adresse, oldAddr: ReqType.Adresse): Promise<ReqType.Adresse> {
        if (
            newAddr.code_postal === oldAddr.code_postal &&
            newAddr.complement === oldAddr.complement &&
            newAddr.numero === oldAddr.numero &&
            newAddr.rue === oldAddr.rue &&
            newAddr.ville === oldAddr.ville
        ) {
            return (Promise.resolve(newAddr));
        } else {
            const token = LoginServices.getInstance().getUserToken();
            return (
                Axios.put(
                    process.env.REACT_APP_ADRESSE_UPDATE_URL! + '&id=' + newAddr.id,
                    newAddr,
                    {
                        headers: { 'X-Access-Token': token },
                    }
                ).then(
                    (response: AxiosResponse<ReqType.Adresse>) => { 
                        return response.data;
                    }
                )
            );
        }
    }

    /**
     * suppression
     * @param {Adresse} adresse
     * @returns {Promise<null>}
     */
    public deleteAdresse(adresse: ReqType.Adresse): Promise<null> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.delete(
            process.env.REACT_APP_ADRESSE_DELETE_URL! + '&id=' + adresse.id,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            () => {
                return null;
            }
        );
    }

    /**
     * valeur par defaut
     * @returns {Adresse}
     */
    public getDefaultAdresse(): ReqType.Adresse {
        const retVal: ReqType.Adresse = {
            code_postal: '',
            complement: '',
            id: null,
            numero: '',
            rue: '',
            ville: '',
        };
        return (retVal);
    }

    /**
     * duplication
     * @param {Adresse} origin
     * @returns {Adresse}
     */
    public duplicateAdresse(origin: ReqType.Adresse): ReqType.Adresse {
        return JSON.parse(JSON.stringify(origin));
    }
}


// WEBPACK FOOTER //
// ./src/services/AdresseService.tsx